import { formatDate } from 'src/utils/formatDate';
import type { QTableColumn } from 'quasar';
import { getRoleLabel, Role } from './enum/Role';
import { Path } from './ResourceModel';
export interface AccountCreateAttributes {
  email: string;
  password: string;
  role: Role;
  name: string;
  name_kana: string;
  code: string;
  notification_emails: string[];
  permissions: Pick<Permission, 'type' | 'id' | 'permission'>[];
}
export interface AccountUpdateAttributes {
  email: string;
  password: string;
  role: Role;
  name: string;
  name_kana: string;
  code: string;
  notification_emails: string[];
  permissions: Pick<Permission, 'type' | 'id' | 'permission'>[];
}
export interface AccountGetAttributes {
  id: string;
  email: string;
  role: Role;
  name: string;
  name_kana: string;
  code: string;
  notification_emails: string[];
  permissions: Permission[];
  created_at: string;
  updated_at: string;
}
export type Permission = {
  type: 'group' | 'resource' | '';
  id: string;
  name: string;
  permission: 'write' | 'read' | 'answer' | '';
  paths: Path[];
};
export class AccountModel {
  id: string;
  name: string;
  name_kana: string;
  code: string;
  role: Role;
  password: string;
  email: string;
  notification_emails: string[];
  permissions: Permission[];
  created_at: string;
  updated_at: string;

  constructor(input?: AccountGetAttributes) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.name_kana = input ? input.name_kana : '';
    this.code = input ? input.code : '';
    this.role = input ? input.role : 'none';
    this.password = '';
    this.email = input ? input.email : '';
    this.notification_emails = input ? input.notification_emails : [];
    this.permissions = input ? input.permissions : [];
    this.created_at = input ? formatDate(input.created_at) : '';
    this.updated_at = input ? formatDate(input.updated_at) : '';
  }

  getId(): string {
    return this.id;
  }
  getAttributes(): AccountGetAttributes {
    return {
      id: this.id,
      email: this.email,
      role: this.role,
      name: this.name,
      name_kana: this.name_kana,
      code: this.code,
      notification_emails: this.notification_emails,
      permissions: this.permissions,
      created_at: this.created_at,
      updated_at: this.updated_at,
    };
  }
  getCreateAttributes(): AccountCreateAttributes {
    return {
      email: this.email,
      password: this.password,
      role: this.role,
      name: this.name,
      name_kana: this.name_kana,
      code: this.code,
      notification_emails: this.notification_emails || [],
      permissions: this.permissions.map((permission) =>
        this.getSendPermission(permission)
      ),
    };
  }
  getUpdateAttributes(): AccountUpdateAttributes {
    return {
      email: this.email,
      password: this.password,
      role: this.role,
      name: this.name,
      name_kana: this.name_kana,
      code: this.code,
      notification_emails: this.notification_emails || [],
      permissions: this.permissions.map((permission) =>
        this.getSendPermission(permission)
      ),
    };
  }
  getSendPermission(
    permission: Permission
  ): Pick<Permission, 'type' | 'id' | 'permission'> {
    return {
      type: permission.type,
      id: permission.id,
      permission: permission.permission,
    };
  }
  static getInitPermission(): Permission {
    return {
      type: '',
      id: '',
      name: '',
      permission: '',
      paths: [],
    };
  }
}
export type AccountCollection = AccountModel[];
export const AccountTableColumns: QTableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    align: 'left',
    field: 'id',
    sortable: true,
  },
  {
    name: 'name',
    label: '名前',
    align: 'left',
    field: 'name',
    sortable: true,
  },
  {
    name: 'code',
    label: '識別コード',
    align: 'left',
    field: 'code',
    sortable: true,
  },
  {
    name: 'role',
    label: '役割',
    align: 'left',
    field: 'role',
    sortable: true,
    format: getRoleLabel,
  },
  {
    name: 'email',
    label: 'Eメール',
    align: 'left',
    field: 'email',
    sortable: true,
  },
  {
    name: 'created_at',
    label: '作成日',
    align: 'left',
    field: 'created_at',
    sortable: true,
  },
];
const hoge: Permission[] = [
  {
    type: 'group',
    id: '01GWR905GFFPZXBCRBTV63AWSK',
    name: 'ステータスCheckerチーム',
    permission: 'answer',
    paths: [
      {
        group_type: {
          id: '01GWR8SN967G0KHEP7R2TVKJVG',
          name: '組織',
        },
        path_items: [
          {
            id: '01GWR8Y93APGZ5GJ3VT9BT2ZTN',
            name: 'システム部',
          },
          {
            id: '01GWR8YW5DB33HYM9VBNW566NR',
            name: '事業開発グループ',
          },
        ],
      },
    ],
  },
  {
    type: 'resource',
    id: '01GXJMFRFHWVEBKFT3NFX1ZEFG',
    name: 'sc.rescuenow.com',
    permission: 'write',
    paths: [],
  },
];
